import { Page } from '../../../models/Page';
import { Box } from '@coolblue-development/becky';
import { useAppContext } from '../../../AppContext';
import { useTelephonyContext } from '../../../contexts/TelephonyContext';
import Settings from './Settings/Settings';
import TelephonyPage from './Telephony/Page/TelephonyPage';
import CcpPanel from './CcpPanel';
import { useEffect } from 'react';
import { datadogLogs } from '@datadog/browser-logs';
import ChatPage from './Chat/Body/ChatPage';
import TelephonyWidgetContainer from './Telephony/Widget/TelephonyWidgetContainer';
import AgentsDashboardPage from './AgentsDashboard/AgentsDashboardPage';
import EmailPage from './Email/EmailPage';
import { FeatureFlag } from '../../constants';
import { useFeatureFlags } from '../../ToolkitPanel/useFeatureFlags';

interface PageContainerProps {
  containerRef?: React.RefObject<HTMLDivElement>;
}

const PageContainer: React.FC<PageContainerProps> = ({ containerRef }) => {
  const { activePage } = useAppContext();
  const { isTelephonyWidgetOpen } = useTelephonyContext();
  const { isFeatureFlagEnabled } = useFeatureFlags();

  const isEmailPageEnabled = isFeatureFlagEnabled(FeatureFlag.EMAIL_PAGE);

  useEffect(() => {
    datadogLogs.logger.info(`Active page:`, { activePage: activePage });
  }, [activePage]);

  return (
    <Box sx={{ width: '100%', margin: '10px' }}>
      {activePage === Page.SETTINGS && <Settings />}
      {activePage === Page.CHAT && <ChatPage />}
      {activePage === Page.TELEPHONY && <TelephonyPage />}
      {activePage === Page.AGENTS_DASHBOARD && <AgentsDashboardPage />}
      {activePage === Page.EMAIL && isEmailPageEnabled && <EmailPage />}
      {containerRef && <CcpPanel containerRef={containerRef} />}
      {isTelephonyWidgetOpen && <TelephonyWidgetContainer />}
    </Box>
  );
};

export default PageContainer;
